import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {Select, Store} from "@ngxs/store";
import {Observable, Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import { ResetPasswordAction} from "../../actions/account.actions";
import {AccountState, AccountStateModel} from "../../states/account.state";
import {CustomValidatorsUtil} from "../../util/custom.validator";
import { SwalUtil } from 'src/app/util/swal-util';
import { ViewIcon, ViewOffIcon } from '@hugeicons-pro/core-stroke-rounded';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: UntypedFormGroup
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  ViewIcon = ViewIcon;
  ViewOffIcon = ViewOffIcon;

  private returnUrl: any;

  @Select(AccountState.getResetPasswordStatus) resetPasswordStatus$: Observable<AccountStateModel>;
  private resetPasswordStatus$Sub: Subscription;
  resetError: boolean = false;
  resetErrorMessage: string = '';
  resetSuccess: boolean = false;
  submitted: boolean = false;

  private token = "";
  private code = "";
  showRules: boolean=true;

  constructor(
    private _builder:UntypedFormBuilder,
    private store: Store,
    private route: ActivatedRoute,
    private router: Router
  ) {


  }

  enviar(values) {
    this.submitted = true;
    this.resetError = false;
    this.resetSuccess = false;
    if(this.resetPasswordForm.valid) {
      this.resetError = false;
      this.resetErrorMessage = null;
      this.store.dispatch(new ResetPasswordAction({code:this.code, password:values.password, token:this.token}))
    }
    // else {
    //   this.resetError = true;
    //   this.resetErrorMessage = "El email ingresado no es válido";
    // }

  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParams['token'];
    this.code = this.route.snapshot.queryParams['code'];

    console.log(this.token)
    console.log(this.code)

    this.resetPasswordForm = this._builder.group({
      password: ['', (Validators.compose([
        // 1. Password Field is Required
        Validators.required,
        // 2. check whether the entered password has a number
        CustomValidatorsUtil.customPatternValidator(/\d/, { hasNumber: true }),
        // 3. check whether the entered password has upper case letter
        CustomValidatorsUtil.customPatternValidator(/[A-Z]/, { hasCapitalCase: true }),
        // 4. check whether the entered password has a lower-case letter
        CustomValidatorsUtil.customPatternValidator(/[a-z]/, { hasSmallCase: true }),
        // 6. Has a minimum length of 8 characters
        Validators.minLength(8)
      ]))],
      passwordConfirm: ['', [Validators.required]],
    },{
      validator: CustomValidatorsUtil.passwordMatchValidator
    })


    this.submitted = false;
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || 'dashboard';

    this.resetPasswordStatus$Sub = this.resetPasswordStatus$.subscribe(status => {
      if(status.resetPasswordError) {
        this.resetSuccess = false;
        this.resetError = true;
        this.resetErrorMessage = status.resetPasswordErrorMessage;
      } else {
        this.resetErrorMessage = null;
        this.resetError = false;
        this.resetSuccess = true;
        this.resetPasswordForm.reset()
        this.resetPasswordForm.markAsPristine()
        if (this.submitted) {
          SwalUtil.fireSuccessMessage('Contraseña Restablecida', 'Iniciá Sesión con tus nuevos datos').then(() => this.redirectToLogin())
        }
      }
    });
  }

  ngOnDestroy() {
    if(this.resetPasswordStatus$Sub) {
      this.resetPasswordStatus$Sub.unsubscribe();
    }
  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  private redirectToLogin() {
    this.router.navigateByUrl('/login');
  }
}
